(function () {
  if (window.DreameryCartUpsellReady) return;
  window.DreameryCartUpsellReady = true;

  var sectionIds = [
    'main-cart-items',
    'cart-icon-bubble',
    'cart-notification-progress',
    'cart-notification-upsell',
    'cart-notification-button',
    'cart-drawer',
    'main-cart-footer'
  ];

  function parseHTML(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function initNasalSwipeFallback(root) {
    if (!root || root.dataset.drNasalSwipeFallback === 'true') return;

    var imageWrap = root.querySelector('.dr-nasal-main__image-wrap');
    if (!imageWrap || imageWrap.hasAttribute('data-dr-nasal-main-swipe')) return;

    var imageEl = root.querySelector('[data-dr-nasal-main-image]');
    var touchStartX = 0;
    var touchStartY = 0;
    root.dataset.drNasalSwipeFallback = 'true';
    imageWrap.style.touchAction = imageWrap.style.touchAction || 'pan-y';

    function thumbButtons() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-dr-nasal-thumb]'));
    }

    function setActiveThumb(thumb) {
      if (!thumb || !imageEl) return;

      thumbButtons().forEach(function (item) {
        item.classList.toggle('is-active', item === thumb);
      });

      var image = thumb.getAttribute('data-image');
      if (image) imageEl.src = image;
      thumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }

    function activeThumbIndex(buttons) {
      var activeIndex = buttons.findIndex(function (button) {
        return button.classList.contains('is-active');
      });
      return activeIndex === -1 ? 0 : activeIndex;
    }

    function moveNasalGallery(direction) {
      var buttons = thumbButtons();
      if (buttons.length < 2) return;
      var nextIndex = (activeThumbIndex(buttons) + direction + buttons.length) % buttons.length;
      setActiveThumb(buttons[nextIndex]);
    }

    imageWrap.addEventListener(
      'touchstart',
      function (event) {
        var touch = event.touches && event.touches[0];
        if (!touch) return;
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
      },
      { passive: true }
    );

    imageWrap.addEventListener(
      'touchend',
      function (event) {
        var touch = event.changedTouches && event.changedTouches[0];
        if (!touch) return;

        var deltaX = touch.clientX - touchStartX;
        var deltaY = touch.clientY - touchStartY;
        if (Math.abs(deltaX) < 42) return;
        if (Math.abs(deltaY) > Math.abs(deltaX)) return;

        moveNasalGallery(deltaX < 0 ? 1 : -1);
      },
      { passive: true }
    );
  }

  function initNasalSwipeFallbacks() {
    document.querySelectorAll('[data-dr-nasal-pdp]').forEach(initNasalSwipeFallback);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNasalSwipeFallbacks);
  } else {
    initNasalSwipeFallbacks();
  }

  function sectionInnerHTML(html, selector) {
    if (!html) return '';
    var doc = parseHTML(html);
    var source = doc.querySelector(selector || '.shopify-section');
    return source ? source.innerHTML : '';
  }

  function refreshCartIcon(html) {
    var target = document.getElementById('cart-icon-bubble');
    if (!target || !html) return;
    target.innerHTML = sectionInnerHTML(html);
  }

  function refreshNotificationSlot(id, html) {
    var target = document.getElementById(id);
    if (!target || !html) return;
    target.innerHTML = sectionInnerHTML(html);
  }

  function syncCartDrawerEmptyState(drawer, sourceDrawer) {
    if (!drawer || !sourceDrawer) return;
    drawer.classList.toggle('is-empty', sourceDrawer.classList.contains('is-empty'));
  }

  function refreshCartItems(html) {
    var target = document.querySelector('#main-cart-items cart-items');
    if (!target || !html) return;

    var source = parseHTML(html).querySelector('cart-items');
    if (source) target.innerHTML = source.innerHTML;
  }

  function refreshCartDrawer(html) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !html) return;

    var doc = parseHTML(html);
    var sourceDrawer = doc.querySelector('cart-drawer');
    var source = doc.querySelector('#CartDrawer');
    var target = drawer.querySelector('#CartDrawer');
    if (!source || !target) return;

    syncCartDrawerEmptyState(drawer, sourceDrawer);
    target.innerHTML = source.innerHTML;

    var overlay = drawer.querySelector('#CartDrawer-Overlay');
    if (overlay && typeof drawer.close === 'function') {
      overlay.addEventListener('click', drawer.close.bind(drawer));
    }

    if (typeof drawer.refreshDeferredSections === 'function') {
      drawer.refreshDeferredSections({ force: true });
    }
  }

  function refreshCartFooter(html) {
    var target = document.querySelector('#main-cart-footer .cart__blocks');
    if (!target || !html) return;

    var source = parseHTML(html).querySelector('#main-cart-footer .cart__blocks');
    if (source) target.innerHTML = source.innerHTML;
  }

  function formatCartTotal(cents, currency) {
    if (typeof cents !== 'number') return '';

    var activeCurrency = currency || 'AUD';
    var amount = (cents / 100).toFixed(2);

    if (activeCurrency === 'AUD') return '$' + amount + ' AUD';

    try {
      return (
        new Intl.NumberFormat('en-AU', {
          style: 'currency',
          currency: activeCurrency
        }).format(cents / 100) +
        ' ' +
        activeCurrency
      );
    } catch (error) {
      return '$' + amount + ' ' + activeCurrency;
    }
  }

  function refreshVisibleCartTotals(cart) {
    if (!cart || typeof cart.total_price !== 'number') return;

    var total = formatCartTotal(cart.total_price, cart.currency);
    if (!total) return;

    document.querySelectorAll('.totals__total-value').forEach(function (target) {
      target.textContent = total;
    });
  }

  function shouldOpenCartDrawer(button, card) {
    return Boolean(
      (button && button.hasAttribute('data-dr-open-cart-drawer')) ||
        (card && card.hasAttribute('data-dr-open-cart-drawer'))
    );
  }

  function replacementLineKeys(button, card) {
    var raw =
      (button && button.getAttribute('data-replace-line-keys')) ||
      (card && card.getAttribute('data-replace-line-keys')) ||
      '';

    return raw
      .split('||')
      .map(function (key) {
        return key.trim();
      })
      .filter(Boolean);
  }

  function cartLineKeysForBreathingBundle(cart) {
    if (!cart || !Array.isArray(cart.items)) return [];

    return cart.items
      .filter(function (item) {
        return (
          item &&
          ['beauty-sleep-mouth-tape', 'dreamery-natural-nasal-strips', 'dreamery-clear-nasal-strips'].indexOf(
            item.handle
          ) !== -1
        );
      })
      .map(function (item) {
        return item.key;
      })
      .filter(Boolean);
  }

  function cartHasBreathingBundle(cart) {
    return Boolean(
      cart &&
        Array.isArray(cart.items) &&
        cart.items.some(function (item) {
          return item && item.handle === 'dreamery-nasal-strips-mouth-tape-sleep-combo';
        })
    );
  }

  function offerName(button, card) {
    return (
      (button && button.getAttribute('data-offer')) ||
      (card && (card.getAttribute('data-offer') || card.getAttribute('data-dr-cart-offer'))) ||
      ''
    );
  }

  function isBreathingBundleOffer(button, card) {
    return offerName(button, card).indexOf('breathing') !== -1;
  }

  function resolveReplacementLineKeys(button, card, knownKeys) {
    var keys = knownKeys || replacementLineKeys(button, card);

    if (!isBreathingBundleOffer(button, card)) {
      return Promise.resolve({ keys: keys, skipAdd: false });
    }

    return fetchCartJson()
      .then(function (cart) {
        if (cartHasBreathingBundle(cart)) {
          return { keys: [], skipAdd: true };
        }

        return {
          keys: keys.length ? keys : cartLineKeysForBreathingBundle(cart),
          skipAdd: false
        };
      })
      .catch(function () {
        return { keys: keys, skipAdd: false };
      });
  }

  function removeReplacementLineKeys(keys) {
    return keys.reduce(function (chain, key, index) {
      return chain.then(function () {
        var body = {
          id: key,
          quantity: 0
        };

        if (index === keys.length - 1) {
          body.sections = sectionIds;
          body.sections_url = window.location.pathname;
        }

        return fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(body)
        }).then(function (response) {
          if (!response.ok) throw new Error('Could not remove replaced cart line');
          return response.json();
        }).then(function (state) {
          return state && state.sections ? state.sections : null;
        });
      });
    }, Promise.resolve(null));
  }

  function openCartDrawer(trigger) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open(trigger);
      return;
    }

    var notification = document.querySelector('cart-notification');
    if (notification && typeof notification.open === 'function') {
      notification.open();
    }
  }

  function refreshCartSections(sections) {
    refreshCartItems(sections['main-cart-items']);
    refreshCartIcon(sections['cart-icon-bubble']);
    refreshNotificationSlot('cart-notification-progress', sections['cart-notification-progress']);
    refreshNotificationSlot('cart-notification-upsell', sections['cart-notification-upsell']);
    refreshNotificationSlot('cart-notification-button', sections['cart-notification-button']);
    refreshCartDrawer(sections['cart-drawer']);
    refreshCartFooter(sections['main-cart-footer']);
  }

  function fetchCartSections() {
    var sectionUrl = window.location.pathname || '/';
    var separator = sectionUrl.indexOf('?') === -1 ? '?' : '&';
    return fetch(sectionUrl + separator + 'sections=' + sectionIds.join(',') + '&_dr=' + Date.now(), {
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Could not refresh cart sections');
      return response.json();
    });
  }

  function resolveCartSections(sections) {
    return sections && sections['main-cart-footer'] ? Promise.resolve(sections) : fetchCartSections();
  }

  function fetchCartJson() {
    return fetch('/cart.js?_dr=' + Date.now(), {
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Could not read cart');
      return response.json();
    });
  }

  function normalizeOptionText(value) {
    return String(value || '').toLowerCase();
  }

  function selectedProductVariantRoutine(card, routine) {
    var scope = card ? card.closest('product-info') || document : document;
    var source = scope.querySelector('variant-selects [data-selected-variant]');
    var variant = null;

    try {
      variant = source ? JSON.parse(source.textContent || '{}') : null;
    } catch (error) {
      variant = null;
    }

    if (!variant) return routine;

    var text = normalizeOptionText(
      [variant.title, variant.option1, variant.option2, variant.option3].concat(variant.options || []).join(' ')
    );
    var hasNatural = text.indexOf('natural') !== -1;
    var hasClear = text.indexOf('clear') !== -1;

    if (hasNatural && !hasClear) routine.finish = 'Natural';
    if (hasClear && !hasNatural) routine.finish = 'Clear';
    if (text.indexOf('small') !== -1) routine.fit = 'Small Fit';
    if (text.indexOf('regular') !== -1) routine.fit = 'Regular Fit';
    if (text.indexOf('90') !== -1) routine.supply = '90-Day Pack';
    if (text.indexOf('30') !== -1) routine.supply = '30-Day Pack';

    return routine;
  }

  function selectedNasalRoutine(card) {
    var routine = {
      finish: card ? card.getAttribute('data-combo-finish') || '' : '',
      fit: card ? card.getAttribute('data-combo-fit') || '' : '',
      supply: card ? card.getAttribute('data-combo-supply') || '' : ''
    };
    routine = selectedProductVariantRoutine(card, routine);

    var root = card ? card.closest('[data-dr-nasal-pdp]') : null;
    if (!root) return routine;

    Array.prototype.slice.call(root.querySelectorAll('[data-dr-nasal-option-group]')).forEach(function (group) {
      var active = group.querySelector('[data-dr-nasal-option].is-active');
      var value = active ? active.getAttribute('data-option-value') || active.getAttribute('data-option-label') || '' : '';
      var text = normalizeOptionText(value);
      var hasNatural = text.indexOf('natural') !== -1;
      var hasClear = text.indexOf('clear') !== -1;

      if (hasNatural && !hasClear) routine.finish = 'Natural';
      if (hasClear && !hasNatural) routine.finish = 'Clear';
      if (text.indexOf('small') !== -1) routine.fit = 'Small Fit';
      if (text.indexOf('regular') !== -1) routine.fit = 'Regular Fit';
      if (text.indexOf('90') !== -1) routine.supply = '90-Day Pack';
      if (text.indexOf('30') !== -1) routine.supply = '30-Day Pack';
    });

    return routine;
  }

  function routineLabel(routine) {
    return [routine.finish, routine.fit, routine.supply]
      .filter(function (value) {
        return Boolean(value);
      })
      .join(' / ');
  }

  function comboVariantsForCard(card) {
    if (!card) return [];
    if (card._drBreathingComboVariants) return card._drBreathingComboVariants;

    var source = card.querySelector('[data-dr-breathing-combo-variants]');
    try {
      card._drBreathingComboVariants = JSON.parse(source ? source.textContent : '[]');
    } catch (error) {
      card._drBreathingComboVariants = [];
    }

    return card._drBreathingComboVariants;
  }

  function comboVariantMatchesRoutine(variant, routine) {
    var optionsText = normalizeOptionText((variant.options || []).join(' '));
    return (
      (!routine.finish || optionsText.indexOf(normalizeOptionText(routine.finish)) !== -1) &&
      (!routine.fit || optionsText.indexOf(normalizeOptionText(routine.fit)) !== -1) &&
      (!routine.supply || optionsText.indexOf(normalizeOptionText(routine.supply)) !== -1)
    );
  }

  function findBreathingComboVariant(card, routine) {
    var variants = comboVariantsForCard(card);
    return (
      variants.find(function (variant) {
        return variant.available && comboVariantMatchesRoutine(variant, routine);
      }) ||
      variants.find(function (variant) {
        return comboVariantMatchesRoutine(variant, routine);
      }) ||
      null
    );
  }

  function syncBreathingUpgradeCard(card) {
    var routine = selectedNasalRoutine(card);
    var variant = findBreathingComboVariant(card, routine);
    if (!variant) return;

    var button = card.querySelector('[data-dr-cart-upsell-add]');
    var routineEl = card.querySelector('[data-dr-upsell-selected-routine]');
    var priceEl = card.querySelector('[data-dr-cart-upsell-price]');
    var saveEl = card.querySelector('.dr-upsell-addon__save');
    var buttonText = 'UPGRADE TO BUNDLE' + (variant.save ? ' & SAVE' : '');

    card.setAttribute('data-combo-finish', routine.finish);
    card.setAttribute('data-combo-fit', routine.fit);
    card.setAttribute('data-combo-supply', routine.supply);
    if (routineEl) routineEl.textContent = routineLabel(routine);
    if (priceEl && variant.price) priceEl.textContent = variant.price;
    if (saveEl) {
      saveEl.textContent = variant.savePercent ? 'Save ' + variant.savePercent + '%' : 'Best Value Bundle';
    }
    if (button) {
      button.setAttribute('data-variant-id', variant.id);
      button.disabled = !variant.available;
      if (!button.hasAttribute('data-dr-cart-upsell-status')) {
        button.textContent = variant.available ? buttonText : 'SOLD OUT';
      }
    }
  }

  function syncBreathingUpgradeCards() {
    document.querySelectorAll('[data-dr-cart-offer="breathing-ritual-combo"]').forEach(syncBreathingUpgradeCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncBreathingUpgradeCards);
  } else {
    syncBreathingUpgradeCards();
  }
  setTimeout(syncBreathingUpgradeCards, 0);

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-dr-nasal-option]')) setTimeout(syncBreathingUpgradeCards, 0);
  });

  document.addEventListener('change', function (event) {
    if (event.target.closest('variant-selects, variant-radios, [data-dr-cart-upsell-variant], input[name="id"]')) {
      setTimeout(syncBreathingUpgradeCards, 0);
    }
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      setTimeout(syncBreathingUpgradeCards, 0);
    });
  }

  function fetchCartDrawerSection() {
    return fetch('/cart?section_id=cart-drawer&_dr=' + Date.now(), {
      cache: 'no-store',
      headers: { Accept: 'text/html' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Could not refresh cart drawer');
      return response.text();
    });
  }

  function setCartCount(count) {
    var cartLink = document.getElementById('cart-icon-bubble');
    if (!cartLink || !count) return;

    var bubble = cartLink.querySelector('.cart-count-bubble');
    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
      cartLink.appendChild(bubble);
    }

    var visibleCount = bubble.querySelector('[aria-hidden="true"]');
    var hiddenCount = bubble.querySelector('.visually-hidden');
    if (visibleCount) visibleCount.textContent = count < 100 ? String(count) : '';
    if (hiddenCount) hiddenCount.textContent = count + (count === 1 ? ' item' : ' items');
  }

  function setNotificationCartCount(count) {
    var link = document.getElementById('cart-notification-button');
    if (!link || !count) return;
    link.textContent = 'View cart (' + count + ')';
  }

  function isCompactCartUpsellButton(button) {
    return Boolean(button && button.classList.contains('dr-cart-recommendation__button'));
  }

  function compactCartUpsellButtonVisual(button) {
    var visual = button.querySelector('[aria-hidden="true"]');
    if (visual) return visual;

    button.textContent = '';
    visual = document.createElement('span');
    visual.setAttribute('aria-hidden', 'true');
    button.appendChild(visual);
    return visual;
  }

  function setCartUpsellButtonStatus(button, status, compactText) {
    if (!button) return;
    button.setAttribute('data-dr-cart-upsell-status', status);

    if (isCompactCartUpsellButton(button)) {
      compactCartUpsellButtonVisual(button).textContent = compactText || '+';
      return;
    }

    button.textContent = status;
  }

  function restoreCartUpsellButtonStatus(button, originalText, originalCompactText) {
    if (!button) return;
    button.removeAttribute('data-dr-cart-upsell-status');

    if (isCompactCartUpsellButton(button)) {
      compactCartUpsellButtonVisual(button).textContent = originalCompactText || '+';
      return;
    }

    button.textContent = originalText;
  }

  function showAddedState(card, count) {
    if (!card) return;

    card.classList.add('is-added');

    var eyebrow = card.querySelector('.dr-cart-upsell__eyebrow');
    var title = card.querySelector('.dr-cart-upsell__title');
    var body = card.querySelector('.dr-cart-upsell__body');
    var note = card.querySelector('.dr-cart-upsell__note');
    var select = card.querySelector('.dr-cart-upsell__select');
    var addedButton = card.querySelector('[data-dr-cart-upsell-add]');

    if (eyebrow) eyebrow.textContent = 'Added to cart';
    if (title) title.textContent = 'Your add-on is in the cart';
    if (body) body.textContent = 'You can check out now or review the full cart before paying.';
    if (note && count) note.textContent = 'Cart now has ' + count + (count === 1 ? ' item.' : ' items.');
    if (select) select.disabled = true;
    if (addedButton) {
      addedButton.classList.remove('is-loading');
      setCartUpsellButtonStatus(addedButton, 'Added', '\u2713');
    }
  }

  function selectedVariantId(card, button) {
    var select = card ? card.querySelector('[data-dr-cart-upsell-variant]') : null;
    return select && select.value ? select.value : button.getAttribute('data-variant-id');
  }

  function finalizeCartUpsell(card, button, sections) {
    return resolveCartSections(sections)
      .catch(function () {
        return null;
      })
      .then(function (resolvedSections) {
        if (resolvedSections) {
          refreshCartSections(resolvedSections);
          if (shouldOpenCartDrawer(button, card)) openCartDrawer(button);
        }
      })
      .then(function () {
        return new Promise(function (resolve) {
          window.setTimeout(resolve, 200);
        });
      })
      .then(fetchCartJson)
      .then(function (cart) {
        setCartCount(cart.item_count);
        setNotificationCartCount(cart.item_count);
        refreshVisibleCartTotals(cart);
        showAddedState(card, cart.item_count);
        return fetchCartDrawerSection()
          .then(refreshCartDrawer)
          .catch(function () {
            return fetchCartSections().then(refreshCartSections);
          })
          .catch(function () {
            return null;
          })
          .then(function () {
            if (shouldOpenCartDrawer(button, card)) openCartDrawer(button);
            return cart;
          });
      });
  }

  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-dr-cart-upsell-variant]');
    if (!select) return;

    var option = select.options[select.selectedIndex];
    var card = select.closest('[data-dr-cart-upsell]');
    var price = card ? card.querySelector('[data-dr-cart-upsell-price]') : null;
    var button = card ? card.querySelector('[data-dr-cart-upsell-add]') : null;

    if (price && option && option.dataset.price) price.textContent = option.dataset.price;
    if (button && select.value) button.setAttribute('data-variant-id', select.value);
    if (button && card && card.classList.contains('dr-cart-upsell--notification') && option && option.dataset.price) {
      button.textContent = 'Add ' + option.dataset.price;
    }
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-dr-cart-upsell-add]');
    if (!button) return;

    event.preventDefault();
    if (button.disabled) return;

    var card = button.closest('[data-dr-cart-upsell]');
    var variantId = selectedVariantId(card, button);
    if (!variantId) return;

    var originalText = button.textContent;
    var originalCompactText = isCompactCartUpsellButton(button)
      ? compactCartUpsellButtonVisual(button).textContent
      : '';
    var replaceKeys = replacementLineKeys(button, card);
    var discountCode = button.getAttribute('data-discount-code') || (card ? card.getAttribute('data-discount-code') : '') || '';
    var postPurchaseOfferId =
      button.getAttribute('data-post-purchase-offer-id') ||
      (card ? card.getAttribute('data-post-purchase-offer-id') : '') ||
      '';
    var lineProperties = {
      _dreamery_offer: button.getAttribute('data-offer') || 'cart-upsell'
    };

    if (discountCode) lineProperties._dreamery_discount_code = discountCode;
    if (postPurchaseOfferId) lineProperties._dreamery_post_purchase_offer_id = postPurchaseOfferId;

    button.disabled = true;
    button.classList.add('is-loading');
    setCartUpsellButtonStatus(button, 'Adding', '+');

    resolveReplacementLineKeys(button, card, replaceKeys)
      .then(function (replacementState) {
        replaceKeys = replacementState.keys || [];
        setCartUpsellButtonStatus(button, 'Added', '\u2713');

        if (replacementState.skipAdd) {
          return fetchCartSections()
            .catch(function () {
              return null;
            })
            .then(function (sections) {
              return finalizeCartUpsell(card, button, sections);
            })
            .catch(function () {
              showAddedState(card);
            });
        }

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(variantId),
                quantity: 1,
                properties: lineProperties
              }
            ],
            sections: sectionIds,
            sections_url: window.location.pathname
          })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Could not add offer');
            return response.json();
          })
          .then(function (state) {
            var refreshedFromAdd = !!(state && state.sections);

            return (replaceKeys.length
              ? removeReplacementLineKeys(replaceKeys).then(function (sections) {
                  return sections || fetchCartSections();
                })
              : Promise.resolve(refreshedFromAdd ? state.sections : null)
            )
              .catch(function () {
                return null;
              })
              .then(function (sections) {
                return finalizeCartUpsell(card, button, sections);
              })
              .catch(function () {
                showAddedState(card);
              });
          });
      })
      .catch(function () {
        button.disabled = false;
        button.classList.remove('is-loading');
        setCartUpsellButtonStatus(button, 'Try again', '!');
        window.setTimeout(function () {
          restoreCartUpsellButtonStatus(button, originalText, originalCompactText);
        }, 1600);
      });
  });
})();
